import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import lotteryDaySlice from '../lotteryDaySlice'
import providerSlice from '../providerSlice'

export const store = configureStore({
    reducer: {
        provider: providerSlice,
        lotteryDay:lotteryDaySlice
    },
    middleware: getDefaultMiddleware({
        serializableCheck: false
    })
})
